import Leaders from "@/views/fanClub/leaders/Leaders";
import LeadersTop from "@/views/fanClub/leaders/LeadersTop";
import LeadersList from "@/views/fanClub/leaders/LeadersList";
import LeadersMemberDetail from "@/views/fanClub/leaders/LeadersMemberDetail";

export default {
  path: "/fanClub",
  component: Leaders,
  children: [
    {
      path: "leaders",
      name: "LeadersTop",
      component: LeadersTop
    },
    {
      path: "leaders/list/:category",
      name: "LeadersList",
      component: LeadersList
    },
    {
      path: "leaders/list/:category/:id",
      name: "LeadersMemberDetail",
      component: LeadersMemberDetail
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/leaders/index.js